import {types, flow} from 'mobx-state-tree';
import * as api from '../../services/api';

const RoleModel = types.model('RoleModel', {
  id: types.identifierNumber,
  code: types.string,
  name: types.string
});

export type RoleModelType = typeof RoleModel.Type;

const RolesListModel = types
  .model('RolesListModel', {
    isLoading: types.optional(types.boolean, false),
    entries: types.map(RoleModel)
  })
  .actions(self => ({
    loadEntries: flow(function*(scope: string) {
      self.isLoading = true;
      const response = yield api.getListRoles(scope);
      if (response.status === 200 && response.data) {
        const entries = response.data.roles;
        if (!entries || entries.length === 0) {
          return;
        }
        const received = entries.reduce(
          (results: {[id: string]: RoleModelType}, r: RoleModelType) => (
            (results[String(r.id)] = r), results
          ),
          {}
        );

        self.entries.merge(received);
      }
    })
  }));

export default RolesListModel;
export type RolesListModelType = typeof RolesListModel.Type;



// WEBPACK FOOTER //
// ./src/models/RolesListModel/RolesListModel.ts